import React, {useState} from 'react';

import classes from "../Navbar/Navbar.module.css";
import logoBlack from "./logoblack.png";
import SearchBar from "../SearchBar/SearchBar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faBars} from '@fortawesome/free-solid-svg-icons';
import SideBar from "../SideBar/SideBar";
import Spinner from 'react-bootstrap/Spinner';


function Navbar(props){
    const [showbar, setShowbar] = useState(false);


    function showSidebar(){
        let temp=!showbar;
        setShowbar(temp);
        console.log(showbar);
        
    }
    return(
        <div className={classes.container}>
            <img className={classes.logo} src={logoBlack} />
            <div>
                <h1 className={classes.heading}>FRAGRANCIA</h1>
            </div>

            
            <div className={classes.sidebarIcon}>
                <a href="javascript:void(0);" class="icon" >
                <FontAwesomeIcon icon={faBars}  className={classes.icon} onClick={showSidebar}/>
                </a>

                {showbar ? <SideBar/> : null}


            </div>
          
           
            <div className={classes.NavbarItems}>
               
                <a href="/" className={classes.links}><h4 className={classes.eachItem}>HOME</h4></a>
                <a href="/products/men" className={classes.links}><h4 className={classes.eachItem}>MEN</h4></a>
                <a href="/products/women" className={classes.links}><h4 className={classes.eachItem}>WOMEN</h4></a>
                <SearchBar className={classes.SearchBar}/>
                

                
                

                
            </div>
           

        </div>
        
    )
}

export default Navbar;
